import React, { useEffect, useState } from 'react';
import { axiosGetCall, axiosPostCall } from '../../../services/apisCall';
import Logger from '../../../lib/Logger';
const logger = new Logger('kycListTable');
import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import { CustomMenu } from '../../../components/menu/customMenu';

import { PaginationTable } from '../../../components/tables/paginationTable';
import TableFilter from './tableFilter';
import { TableCell, Box, List, ListItem, Button, } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import moment from 'moment';
import { ConfirmDialog } from 'src/components/custom-dialog';
import DeleteIcon from '@mui/icons-material/Delete';

const columns = [
    { id: 'mobile_number', label: 'Mobile Number', minWidth: 150, align: 'center' },
    { id: 'create_date', label: 'Create Date', minWidth: 100, align: 'center' },
    { id: 'actions', label: 'Actions', minWidth: 70, align: 'center' },
];


export const SmsRealNumberTable = ({ loadit, setUpdateUserId, forceLoad }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [rows, setRows] = useState([]);
    const [count, setCount] = useState(0);

    const [search, setSearch] = useState('');
    const [load, setLoad] = useState(true);
    const [networkError, setNetworkError] = useState(false);
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDelete, setOpenDelete] = useState(false);
    const open = Boolean(anchorEl);

    const handleChange = (value) => setSearch(value);

    const getRealNumberList = async () => {
        const skip = rowsPerPage * page;
        try {
            const params = { skip, limit: rowsPerPage };
            if (search) params.number = search;
            setNetworkError(false);
            const result = await axiosGetCall('getSmsRealNumberList', params);
            setRows(result.realNumberList);
            setCount(result.totalRealNumberCount);
        } catch (error) {
            logger.error('Real Number List', error);
            setNetworkError(true);
            setRows([]);
            setCount(0);
            renderErrorMessage(error?.message);
        }
        setLoading(false);
    };

    useEffect(() => {
        // if (load) {
        setLoading(true);
        getRealNumberList();
        setLoad(false);
        forceLoad(false);

        // }
    }, [load, loadit]);

    const handleClick = (event, user) => {
        setAnchorEl(event.currentTarget);
        setUserData(user);
    };
    const handleDeleteClick = () => {
        setOpenDelete(true);
        setAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleCloseDelete = () => {
        setAnchorEl(null);
        setOpenDelete(false);
    };

    const handleConfirmDelete = async () => {
        try {
            const payload = {
                number: [userData.mobile_number],
            };
            const data = await axiosPostCall('deleteNumber', payload);
            renderSuccessMessage(data?.message);
            getRealNumberList();
            setOpenDelete(false);
            setAnchorEl(null);
        } catch (error) {
            logger.error('Gateway List change status', error);
            renderErrorMessage(error?.message);
        }
    };

    const tableFilter = (
        <TableFilter
            search={search}
            handleChange={handleChange}
            setLoad={setLoad}
            count={count}
            setPage={setPage}
        />
    );

    const ActionJsx = (id, align, value, ...other) => {
        const user = other[3];

        return (
            <TableCell
                key={id}
                align={align}
                sx={{
                    color: 'grey.400',
                    borderBottom: '0.5px dashed',
                    borderColor: 'grey.300',
                    size: 'small',
                }}
            >
                <MoreVertIcon
                    sx={{ color: 'grey.700', cursor: 'pointer', height: '18px', width: '18px' }}
                    aria-controls={open ? 'filters-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={(e) => handleClick(e, user)}
                />
            </TableCell>
        );
    };
    const Content = () => (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
            }}
        >
            <List>
                <ListItem
                    sx={{
                        display: 'flex',
                        gap: '7px',
                        fontWeight: 400,
                        color: 'grey.700',
                        '&:hover': {
                            color: 'grey.800',
                            backgroundColor: 'grey.300',
                            cursor: 'pointer',
                        },
                    }}
                    onClick={handleDeleteClick}
                >
                    <DeleteIcon sx={{ color: '#d32f2f', height: '17px' }} />
                    Delete
                </ListItem>
            </List>
        </Box>
    );

    const createdatejsx = (id, align, value) => {
        const date = moment(Number(value) * 1000);
        const formattedDate = date.format('D MMM, YYYY');
        const formattedTime = date.format('h:mm A');
        return (
            <TableCell
                key={id}
                align={align}
                sx={{
                    color: 'grey.700',
                    borderBottom: '0.5px dashed',
                    borderColor: 'grey.300',
                }}
            >
                <>
                    <Box>{value !== '' ? `${formattedDate} ${formattedTime}` : '-'}</Box>
                </>
            </TableCell>
        );
    };


    const ActionModals = () => {
        return <CustomMenu anchorEl={anchorEl} handleClose={handleClose} Content={Content} />;
    };
    return (
        <>
            <PaginationTable
                page={page}
                tableFilter={tableFilter}
                ActionJsx={ActionJsx}
                ActionModals={ActionModals}
                setLoad={setLoad}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                count={count}
                error={networkError}
                loading={loading}
                setLoading={setLoading}
                rows={rows}
                columns={columns}
                handleChange={handleChange}
                search={search}
                calculatedHeight={288}
                createdatejsx={createdatejsx}
            />
            <ConfirmDialog
                open={openDelete}
                onClose={handleCloseDelete}
                title="Delete Gateway"
                content={
                    <span>
                        Are you sure you want to delete this Gateway {userData.mobile_number}?

                    </span>
                }
                action={
                    <Button
                        color="secondary"
                        variant="contained"
                        sx={{
                            color: '#fff',
                            height: '30px',
                            backgroundColor: 'primary.main',
                            '&:hover': {
                                backgroundColor: 'primary.main',
                            },
                            boxShadow: "none",
                            marginRight: '10px'
                        }}
                        onClick={() => handleConfirmDelete()}
                    >Confirm
                    </Button>
                }
            />
        </>
    );
};
